import React, { Component, useEffect } from 'react';
import { Row, Col, Button, List } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import './Views.scss';

const CURRENT_HELP = `
  <div>
    <p><strong>Purpose:</strong> The current access method just means whether the client has any access to a device already, right now.  
    For example, a client may still be using an access method they got 10 years ago, even though it’s not working as well for them as it once did.   
    </p>
    <p>Talking about any current access methods helps you and the client understand what problems need to be solved.  
    And the current access methods form a baseline that can be used for comparisons with any new access methods you decide to try. 
    </p>
    <p>You can include as many current access methods as you want. These should be methods that the client uses regularly.  
    In a separate section, you’ll have a chance to enter methods that the client may have tried before but no longer uses.  
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  currentMethods: PropTypes.arrayOf(PropTypes.object),
  onAddMethod: PropTypes.func.isRequired,
  onDeleteMethod: PropTypes.func.isRequired,
  onEditMethod: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  currentMethods: []
};

//content sub-component with unique content for this page
class HistoryCurrentMethodsReviewContent extends Component {

  edit(index){
    this.props.onEditMethod(index);
  }
  delete(index){
    this.props.onDeleteMethod(index);
  }

  //Render the view for current methods.
  render(){
    const currentMethods = this.props.currentMethods; //TODO more complex
    const onAddMethod = this.props.onAddMethod;
    
    //show a table listing the currentMethods
    return(
    <>
      <Row>
        <Col>
          {currentMethods.map((item, index) =>
          <Row key={index} className="aa-review-row border-top">
            <Col>
              {item.name}
            </Col>
            <Col>
              <Button className="aa-inner-button float-end" color="secondary" outline onClick={this.delete.bind(this,index)}> Delete </Button>
              <Button className="aa-inner-button float-end" color="secondary" outline onClick={this.edit.bind(this,index)}> Edit </Button>
            </Col>
          </Row>
          )}  
        </Col>
        <Col lg={2}></Col>
      </Row>
      <Row className="aa-review-row">
        <Col>
          <Button onClick={onAddMethod}>Add a method</Button>  
        </Col>
        <Col lg={2}></Col>
      </Row>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryCurrentMethodsReview(props) {

  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const currentMethods = props.currentMethods;
  const onAddMethod = props.onAddMethod;
  const onEditMethod = props.onEditMethod;
  const onDeleteMethod = props.onDeleteMethod;
  const saveCurrentMethods = props.saveCurrentMethods;
  const onContinue = props.onContinue;
  
  console.log("rendering GatherInfoHistoryCurrentMethodsReview");

  const pageDataNoMethods = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    title: `Enter ${firstName}'s current access methods`,
    subTitle: `Include methods that ${firstName} currently uses or practices with at least occasionally.`,
    learnMore: {linkText: "Learn More about what we mean by a current access method and why it matters.",
                title: "Current Access Method",
                content: "Here is more info about Current Access Method."
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }
  const pageDataMethods = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Review ${firstName}'s current access methods`,
    subTitle: "Here's what you've entered so far.",
    learnMore: {linkText: "Learn More about what we mean by a current access method and why it matters",
                title: "Current Access Method",
                content: CURRENT_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  //Save the current methods to the App state whenever this component unmounts
  //For this component, this happens on: 
  //navigation with buttons (Back, Continue) or tabs (a new section)
  //click Edit to edit an existing method. -- this save is redundant but not wrong
  //click Add another method to add a new method -- this save is redundant but not wrong
  useEffect(() => {
    console.log('GIHCurrReview mounted');
    return () => {
      console.log('GIHCurrReview unmounting and saving...');
      saveCurrentMethods();
    }
  }, [saveCurrentMethods])
  
  return(
    <>
        <Body page={(currentMethods.length === 0) ? pageDataNoMethods : pageDataMethods} 
          contentComponent={
            <HistoryCurrentMethodsReviewContent 
              currentMethods={currentMethods}
              onAddMethod={onAddMethod}
              onEditMethod={onEditMethod}
              onDeleteMethod={onDeleteMethod}
            />
          }
          onContinue={onContinue} 
        />
    </>
  );
}

GatherInfoHistoryCurrentMethodsReview.propTypes = propTypes;
GatherInfoHistoryCurrentMethodsReview.defaultProps = defaultProps;

export default GatherInfoHistoryCurrentMethodsReview;